import differenceInYears from 'date-fns/difference_in_years'; 

function getFullName({ firstName, lastName }) {
  return `${firstName}${lastName}`;
}

function getFormatDate({ year, month, day }) {
  return `${year}-${month}-${day}`;
}

function getFormatAddress({ city, area, road }) {
  return `${city}${area}${road}`;
}

function getGender(identityNo) {
  const [, genderChar] = identityNo;
  const genderNum = parseInt(genderChar, 10);
  const genderObj = {
    value: genderNum > 1 ? 'F' : 'M',
    text: genderNum > 1 ? '女' : '男'
  };
  return genderObj;
}

function getAge(dateOfBirth) {
  const formatBirth = Object.keys(dateOfBirth).reduce((acc, key) => {
    const num = parseInt(dateOfBirth[key], 10);
    const val = key === 'month' ? num - 1 : num;
    return { ...acc, [key]: val };
  }, {});
  const { year, month, day } = formatBirth;
  return differenceInYears(new Date(), new Date(year, month, day));
}

const userInfo = ({ isLogin, profile,nowActivity }, getters, rootState) => {
//const userInfo = ({ isLogin, profile }, getters, rootState) => {
  const isCheckouting = rootState.checkout.insuInfos.length !== 0;
  if (!isLogin) return { isCheckouting };
  const { name, dateOfBirth, identityNo, address , refagent} = profile;
  return { 
    age: getAge(dateOfBirth),
    fullName: getFullName(name),
    gender: getGender(identityNo),
    dateOfBirth: getFormatDate(dateOfBirth),
    address: getFormatAddress(address),
    refagent: refagent,
    isCheckouting,
    nowActivity
  };
};

function getCountOfOrderType(orders) {
  const obj = { TRA: 0, AUT: 0, MOT: 0, VCN:0, PET: 0 };   //20210510 會員首頁 各險種orders預設  //20210830 Wen modify   TRA: 0, AUT: 0, MOT: 0, PET: 0, ACD: 0 , VCN:0  
  return orders.reduce((acc, order) => {
    if (!order) return acc;
    acc[order.orderType] += 1;
    return acc;
  }, obj);
}

const orderInfo = ({ orders, advisorys }) => {
  if (!orders || !advisorys) return null;
  return {
    countOfOrderType: getCountOfOrderType(orders)
  };
};

export default {
  userInfo,
  orderInfo
};